const PreferencesPage = () => {
	return (
		<div>
			<h1>Preferences</h1>
		</div>
	);
};

export default PreferencesPage;
